<template>
  <div class="input-wrap" :class="contList">
    <h5>{{ title }}</h5>
    <input :type="inputType" :placeholder="baseText" v-model.trim="model" @keyup.enter="onEnter">
    <i v-if="model.length && type !== 'password'"
         class="icon icon--close14"
         @click="onClickReset"></i>
    <i v-if="type === 'password'"
         class="icon icon--pw-eye"
         :class="{on: !toggleInputType}"
         @click="toggleInputType = !toggleInputType"></i>

    <p class="error-text">{{ errorText }}</p>
  </div>
</template>

<script>
export default {
  name: 'UiInput',
  props: {
    title: {
      type: String,
      default: ''
    },
    errorText: {
      type: String,
      default: ''
    },
    baseText: {
      type: String,
      default: null
    },
    contList: {
      type: String,
      default: null
    },
    defaultText: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'text'
    },
    index: {
      type: Number,
      default: 0
    },
    parentIndex: {
      type: Number,
      default: 0
    },
    modelValue: {
      default: '',
      required: false
    },
    reset: {
      default: true,
      type: Boolean
    }
  },
  components: {

  },
  watch: {
    modelValue (value) {
      this.model = value
    },
    model (value) {
      this.$emit('input', value, this.index, this.parentIndex)
    }
  },
  created () {
    if (this.modelValue) {
      this.model = this.modelValue
    }
  },
  destroyed () {
  },
  methods: {
    onClickReset () {
      this.model = ''
      this.$emit('input', this.model)
    },
    onEnter () {
      this.$emit('input', this.model)
      this.$emit('submit')
    }
  },
  data () {
    return {
      model: '',
      toggleInputType: true
    }
  },
  computed: {
    inputType () {
      if (this.type === 'password') {
        return this.pwShowToggle ? 'password' : 'text'
      } else if (this.type === 'number') {
        return 'text'
      } else {
        return this.type
      }
    },
    pwShowToggle () {
      if (this.type === 'password') {
        return this.toggleInputType
      } else {
        return false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.input-wrap {
  height: 110px;
  position: relative;
  h5 {
    font-size: 13px;
    font-weight: 500;
    color: #767676;
    margin: 0 0 5px 5px;
  }
  input {
    width: 100%;
    height: 38px;
    box-sizing: border-box;
    padding: 12px;
    border-radius: 6px;
    border: solid 1px #bbb;
    background: #fff;
    color: #2f2f2f;
    font-size: 14px;
    &::placeholder {
      font-size: 14px;
      color: #bbb;
    }
    &:disabled {
      border: 1px solid red;
    }
  }
  .icon--pw-eye {
    position: absolute;
    top: 24px;
    right: 10px;
    cursor: pointer;
    background-color: transparent;
    display: block;
    width: 25px;
    height: 25px;
    background: url('../../assets/images/icon_pw_eye_off.svg') no-repeat center;
    cursor: pointer;
    background-size: 20px 20px;

    &.on {
      background: url('../../assets/images/icon_pw_eye_on.svg') no-repeat center;
    }
  }
  .icon--close14 {
    position: absolute;
    top: 30px;
    right: 15px;
    width: 14px;
    height: 14px;
    background: url('../../assets/images/icon_close_size14.svg') no-repeat center;
    cursor: pointer;
    background-size: 14px 14px;
  }
  .error-text {
    font-size: 12px;
    font-weight: 500;
    color: #1990c2;
    margin: 5px 0 0 5px;
  }
  &.error {
    input {
      border: 1px solid #e60724;
    }
    .error-text {
      color: #e60724;
    }
  }

  // &.editor {
  //   height: auto;
  //   margin-bottom: 65px;
  //   input {
  //     height: 250px;
  //   }
  // }

  &.sublist {
    position: relative;
    text-align: center;
    height: 80px;
    box-sizing: border-box;
    padding-right: 40px;
    h5 {
      display: inline-block;
    }
    input {
      width: 595px;
      display: inline-block;
      margin-left: 10px;
    }
    .icon--close14 {
      top: 12px;
      right: 95px;
    }
    .error-text {
      text-align: left;
      margin-left: 135px;
    }
  }
  &.login {
    height: 85px;
  }

  &.info {
    height: auto;
  }
}

@media all and (max-width: 990px) {

  .input-wrap {
    height: 110px;
    position: relative;
    &.sublist {
      padding: 0;
      text-align: left;
      input {
        width: calc(100% - 170px);
        display: inline-block;
        margin-left: 10px;
      }
    }
  }

}
</style>
